import React, { useEffect, useState } from "react";
import { Button } from "../../../common/components/Button/index.tsx";
import {
  UserData,
  Session,
  SessionOverlayProps,
} from "../../../types/seatApproval.ts";
import styles from "./index.module.scss";
import { Avatar, Drawer } from "@mui/material";
import listBullets from "../../../assets/images/listView.svg";
import { useNavigate } from "react-router-dom";
import { X } from "lucide-react";
import Loader from "../../../common/components/Loader/index.tsx";
import defaultProfileIcon from "../../../assets/images/default-profile.svg";
import HdbSeekersListAdmin from "../../../pages/HdbSeekersListAdmin/index.tsx";
import personIcon from "../../../assets/images/no-seeker-found.svg";
import UserCard from "../../../common/components/UserCard/index.tsx";
import { ApprovalStatus } from "../../../constants/textConstants.ts";
import ListPagination from "../../../common/components/ListPagination/index.tsx";
import CheckBoxChecked from "../../../assets/images/checkBoxChecked.svg";
import CheckBoxUnchecked from "../../../assets/images/checkboxUnchecked.svg";
import searchIcon from "../../../assets/images/search-icon.svg";
import DropDown from "../../../assets/images/dropdownDown.svg";
import UserPreferencesDropdown from "../../../common/components/UserPreferenceDropDown/index.tsx";

const actions = [
  { id: 1, name: "swap" },
  { id: 2, name: "hold" },
  { id: 3, name: "reject" },
];

const programTags = ["hdb1", "hdb2", "hdb3", "msd1", "msd2"].map((tag) =>
  tag.toUpperCase(),
);

const SessionOverlay: React.FC<SessionOverlayProps> = ({
  session,
  isOpen,
  onClose,
  selectedSession,
  setSelectedSession,
  sessionId,
  users,
  handleBless,
  loading,
  programId,
  sessiondata,
  totalRecords,
  customTitle,
  preferredName,
  noSeekerMessage,
  isCardClicked,
  setFlippedUserId,
  flippedUserId,
  kpiData,
  isDropdownUserList,
  handleBlessed,
  onSeekerSelect,
  excludedUserId,
  fromSessionGrid = false,
  handleSessionPageChange,
  handleSessionPageSizeChange,
  sessionpaginationProps,
  sessions = [],
  sessionSearchText,
  setSessionSearchText,
  fetchApprovedUsersForSession,
  overlayLoader = false,
  setSelectedFilter,
  selectedFilter = {},
  isOverlayFromSessionGrid = false,
  showOverlay,
}) => {
  // const [loading, setLoading] = useState(false);
  console.log(isOpen, "isOpen in SessionOverlay");
  console.log("session:", sessionpaginationProps);

  const [sessionsFetched, setSessionsFetched] = useState(sessions);

  const navigate = useNavigate();
  const getInitials = (name: string): string =>
    name
      .split(" ")
      .map((word) => word.charAt(0))
      .join("")
      .toUpperCase()
      .slice(0, 2);
  // Generated by Copilot
  const filteredUsers = excludedUserId
    ? users.filter(
        (u) =>
          String(u.id) !== String(excludedUserId) &&
          (fromSessionGrid
            ? true
            : u?.approvalStatus === ApprovalStatus?.APPROVED),
      )
    : fromSessionGrid
      ? users
      : users.filter((u) => u?.approvalStatus === ApprovalStatus?.APPROVED);

  // Per-user flip and action state
  const [flipped, setFlipped] = useState<{ [userId: string]: boolean }>({});
  const [selectedAction, setSelectedAction] = useState<{
    [userId: string]: { id: number; name: string } | null;
  }>({});
  const [selectedTag, setSelectedTag] = useState<{
    [userId: string]: string | null;
  }>({});
  const handleActionClick = (
    userId: string,
    action: { id: number; name: string },
  ) => {
    setSelectedAction((prev) => ({ ...prev, [userId]: action }));
    setFlipped((prev) => ({ ...prev, [userId]: true }));
  };

  const handleBack = (userId: string) => {
    setFlipped((prev) => ({ ...prev, [userId]: false }));
    setSelectedAction((prev) => ({ ...prev, [userId]: null }));
    setSelectedTag((prev) => ({ ...prev, [userId]: null }));
  };

  const handleCheckboxChange = (key: string, value: string) => {
    setSelectedFilter((prev) => {
      // Create new filter state
      const newFilters = { ...prev };

      if (prev[key] === value) {
        // Uncheck: remove the key
        delete newFilters[key];
      } else {
        // Check: add/update the key-value
        newFilters[key] = value;
      }

      // Call API with all selected filters
      fetchApprovedUsersForSession({
        kpiCategory: "allocated",
        kpiFilter: selectedSession?.kpiFilter,
        swapRequests:
          newFilters.wantsSwap === "wants_swap" ? "wants_swap" : undefined,
        shiftRequests:
          newFilters.canShift === "can_shift" ? "can_shift" : undefined,
      });

      return newFilters;
    });
  };
  const [searchText, setSearchText] = useState<string>("");
  const handleSearch = (value: string) => {
    setSearchText(value);
  };
  const [selectedProgram, setSelectedProgram] = useState<string>(
    (sessions ?? [])[0]?.name || "Select Program",
  );
  const handlePrefSelect = (pref: any) => {
    setSelectedProgram(pref?.name);
  };
  const handleLocalSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    console.log("value:", value);
    if (setSessionSearchText) {
      setSessionSearchText(value);
    }
    handleSessionPageChange && 
    handleSessionPageChange(1); // Reset to first page on search
  };
  useEffect(() => {
    if (showOverlay) {
      setSelectedFilter({}); // Reset filters when overlay opens
    }
  }, [showOverlay]);
  const getButtonText = (actionName: string) => {
    if (actionName === "swap") return "bless";
    if (actionName === "reject") return "Reject";
    if (actionName === "hold") return "Hold";
    return "Action";
  };
  // React.useEffect(() => {
  //   if (isOpen && users.length === 0) {
  //     setLoading(true);
  //   } else {
  //     setLoading(false);
  //   }
  // }, [isOpen, users.length]);
  console.log("sessions dropdown", sessions);
  return (
    <Drawer
      anchor={"right"}
      open={isOpen}
      onClose={onClose}
      PaperProps={{ className: styles.sessionOverlay }}
    >
      <div className={`${styles.overlay} ${isOpen ? styles.open : ""}`}>
        {overlayLoader && <Loader type="large" />}
        <div className={styles.overlayHeader}>
          <h2 className={styles.overlayTitle}>
            {!isOverlayFromSessionGrid
              ? customTitle
              : `${sessionpaginationProps?.sessiontotalRecords} seeker${users?.length !== 1 ? "s" : ""} in ${session?.name}`}
          </h2>
          <div
            className={styles.headerDivider}
            style={{
              width: session?.name === "YTD" ? "20%" : "22%",
            }}
          />
          <div className={styles.headerRight}>
            {isOverlayFromSessionGrid && (
              <>
                <img
                  src={listBullets}
                  alt="Menu Icon"
                  className={styles.menuIcon}
                />
                <span
                  className={styles.listViewText}
                  onClick={() => {
                    // Find the index of the current session in sessiondata
                    let sessionIndex = -1;
                    if (Array.isArray(sessiondata) && session?.name) {
                      sessionIndex = sessiondata.findIndex(
                        (s: any) => s.name === session.name,
                      );
                    }
                    navigate(`/admin/hdb-dashboard/${programId}`, {
                      state: {
                        sessiondata: sessiondata,
                        totalRecords: totalRecords,
                        sessionId: sessionId,
                        activateTab: "registrations",
                      },
                    });
                  }}
                >
                  List view
                </span>
                <span className={styles.divider}>|</span>
              </>
            )}
            <button className={styles.closeButton} onClick={onClose}>
              ×
            </button>
          </div>
        </div>
        {isCardClicked && !isOverlayFromSessionGrid && (
          <>
            <div className={styles.filterContainer}>
              {/* <UserPreferencesDropdown
          preferences={(sessionsFetched ?? []).map((pref) => ({
            name: pref.name,
            value: pref.id || pref.name, // Use pref.id if available, else name
          }))}
          onSelect={handlePrefSelect}
          highlightPreference={"overLay"}
        /> */}
              <p>view only: </p>
              {[
                { key: "canShift", value: "can_shift", label: "Can shift" },
                { key: "wantsSwap", value: "wants_swap", label: "Wants swap" },
              ].map(({ key, value, label }) => {
                return (
                  <label key={value} className={styles.filterButton}>
                    <input
                      type="checkbox"
                      name={key}
                      checked={selectedFilter[key] === value}
                      value={value}
                      onChange={() => handleCheckboxChange(key, value)}
                      style={{ display: "none" }}
                    />
                    <img
                      src={
                        selectedFilter[key] === value
                          ? CheckBoxChecked
                          : CheckBoxUnchecked
                      }
                      alt={
                        selectedFilter[key] === value ? "Checked" : "Unchecked"
                      }
                      className={styles.customCheckbox}
                    />
                    {label}
                  </label>
                );
              })}
            </div>

            <div className={styles.searchInputWrapper}>
              <img
                src={searchIcon}
                alt="Search Icon"
                className={styles.searchIcon}
              />
              <input
                type="text"
                className={styles.searchInput}
                autoFocus
                value={sessionSearchText}
                placeholder="Search seeker with name"
                onChange={handleLocalSearchChange}
                data-testid="search-input"
              />
            </div>
          </>
        )}
        <div className={styles.usersList}>
          {loading && <Loader type="large" />}

          {users?.length === 0 ? (
            <div className={styles.noSeekerContainer}>
              <img
                src={personIcon}
                alt="No seeker found"
                className={styles.noSeekerImage}
              />
              {!isOverlayFromSessionGrid && !isCardClicked && (
                <div className={styles.noSeekerText}>
                  {` No seeker named “${preferredName}” found`}
                </div>
              )}
              {(isOverlayFromSessionGrid || isCardClicked) && (
                <div className={styles.noSeekerText}>
                  {` No seeker Found`}
                </div>
              )}
            </div>
          ) : (
            filteredUsers?.map((user) =>
              isCardClicked ? (
                <div>
                  <div className={styles.userCard} key={user.id}>
                    <UserCard
                      user={user}
                      getInitials={getInitials}
                      // handleBless={handleBless}
                      // handleShowAllMatches={handleShowAllMatches}
                      sessionId={sessionId}
                      setSelectedSession={setSelectedSession}
                      isFlipped={flippedUserId === user.id}
                      onFlip={() =>
                        !user?.status?.isPending &&
                        setFlippedUserId &&
                        setFlippedUserId(user.id)
                      }
                      onCloseFlip={() =>
                        setFlippedUserId && setFlippedUserId(null)
                      }
                      disabled={user.status?.isPending}
                      programsList={kpiData?.unallocatedPrograms.map(
                        (program) => ({
                          id: program.programId,
                          name: program.programName,
                        }),
                      )}
                      allocatedProgramId={
                        isDropdownUserList ? user.allocatedSessionId : null
                      }
                      highlightAllocated={isDropdownUserList}
                      handleBlessed={handleBlessed}
                      handleSeekerClick={() => {
                        onSeekerSelect && onSeekerSelect(user);
                        onClose(); // Close overlay after selection
                      }}
                      selectedFilter={selectedFilter}
                      isOverlay={false}
                    />
                  </div>
                </div>
              ) : (
                <div key={user.id}>
                  <div
                    className={`${styles.userCard} ${flipped[user.id] ? styles.flipped : ""}`}
                  >
                    {!flipped[user.id] ? (
                      <UserCard
                        user={user}
                        getInitials={getInitials}
                        sessionId={sessionId}
                        setSelectedSession={setSelectedSession}
                        isFlipped={flippedUserId === user.id}
                        onFlip={() =>
                          !user?.status?.isPending &&
                          setFlippedUserId &&
                          setFlippedUserId(user.id)
                        }
                        onCloseFlip={() =>
                          setFlippedUserId && setFlippedUserId(null)
                        }
                        disabled={user.status?.isPending}
                        programsList={kpiData?.unallocatedPrograms.map(
                          (program) => ({
                            id: program.programId,
                            name: program.programName,
                          }),
                        )}
                        allocatedProgramId={
                          isDropdownUserList ? user.allocatedSessionId : null
                        }
                        highlightAllocated={isDropdownUserList}
                        handleBlessed={handleBlessed}
                        handleSeekerClick={() => {
                          onSeekerSelect && onSeekerSelect(user);
                        }}
                        selectedFilter={selectedFilter}
                        isOverlay={false}
                      />
                    ) : (
                      <div className={styles.flippedCard}>
                        <div className={styles.userCardContent}>
                          <div className={styles.userAvatar}>
                            <Avatar
                              alt="Remy Sharp"
                              src={user.profileImage || defaultProfileIcon}
                              sx={{
                                width: 100,
                                height: 100,
                                border: "1px solid #fffff",
                              }}
                              data-testid="user-avatar"
                            />
                          </div>
                          <div className={styles.userInfo}>
                            <h3 className={styles.redirectText}>
                              Redirect {user.fullName} to their aligned program
                            </h3>
                            {/* Only show program tags if swap is selected */}
                            {selectedAction[user.id]?.name === "swap" && (
                              <div className={styles.userDetails}>
                                {programTags.map((tag) => (
                                  <span
                                    key={tag}
                                    className={`${styles.preferenceChip} ${selectedTag[user.id] === tag ? styles.selected : ""}`}
                                    onClick={() =>
                                      setSelectedTag((prev) => ({
                                        ...prev,
                                        [user.id]: tag,
                                      }))
                                    }
                                    style={{ cursor: "pointer" }}
                                  >
                                    {tag}
                                  </span>
                                ))}
                              </div>
                            )}
                            <Button
                              onClick={() => {
                                console.log(
                                  "Selected action for user:",
                                  user.id,
                                  selectedAction[user.id],
                                );
                                if (
                                  selectedAction[user.id]?.name === "swap" &&
                                  selectedTag[user.id]
                                ) {
                                  console.log(
                                    "Blessing user:",
                                    user.id,
                                    "with tag:",
                                    selectedTag[user.id],
                                  );
                                  handleBless(
                                    user,
                                    sessionId,
                                    selectedTag[user.id]!,
                                  );
                                }
                                handleBack(user.id);
                              }}
                              buttonClassName={styles.actionButton}
                              buttonTextClassName={styles.actionButtonText}
                            >
                              {selectedAction[user.id]
                                ? getButtonText(selectedAction[user.id]!.name)
                                : "Action"}
                            </Button>
                          </div>
                        </div>
                        <X
                          size={18}
                          onClick={() => handleBack(user.id)}
                          className={styles.closeIconFlipCard}
                        />
                      </div>
                    )}
                  </div>
                </div>
              ),
            )
          )}
          <div>
            {sessionpaginationProps?.sessiontotalRecords > 10 && (
              <ListPagination
                pageSize={sessionpaginationProps?.sessionpageSize}
                totalRecords={sessionpaginationProps?.sessiontotalRecords}
                currentPage={sessionpaginationProps?.sessioncurrentPage}
                onPageChange={handleSessionPageChange}
                onPageSizeChange={handleSessionPageSizeChange}
                pageSizeOptions={[5, 10, 20, 50]}
              />
            )}
          </div>
        </div>
      </div>
    </Drawer>
  );
};

export default SessionOverlay;
